import css from "../../css/find-agent/agents.module.css";

import React from "react";
import Agent from "./Agent";
import PropTypes from "prop-types";

const PAGE_SIZE = 6;

class Agents extends React.PureComponent {
    state = {
        page: 1,
    };

    prevPage = () => {
        this.setState({
            page: this.state.page - 1,
        });
    };

    nextPage = () => {
        this.setState({
            page: this.state.page + 1,
        });
    };

    hasPrevPage = () => {
        return this.state.page > 1;
    };

    hasNextPage = () => {
        const agentsCount = this.props.agents.length;

        return this.state.page < Math.ceil(agentsCount / PAGE_SIZE);
    };

    render() {
        const { agents } = this.props;
        const { page } = this.state;

        const pageAgents = agents.filter((agent, index) => {
            return index >= PAGE_SIZE * (page - 1) && index < PAGE_SIZE * page;
        });

        return (
            <div className={css.agents}>
                {this.hasPrevPage() && (
                    <a
                        className={css.prevButton}
                        onClick={this.prevPage}
                        role="button"
                        aria-label="Previous"
                        style={{ cursor: "pointer" }}
                    />
                )}
                <div className={css.list}>
                    {pageAgents.map((agent) => (
                        <Agent agent={agent} key={agent.id} />
                    ))}
                </div>
                {this.hasNextPage() && (
                    <a
                        className={css.nextButton}
                        onClick={this.nextPage}
                        role="button"
                        aria-label="Next"
                        style={{ cursor: "pointer" }}
                    />
                )}
            </div>
        );
    }
}

Agents.propTypes = {
    agents: PropTypes.array.isRequired,
};

export default Agents;
